import { useRef, useEffect } from 'react';
import useSSRLayoutEffect from '../useSSRLayoutEffect/3f7dfe597927d283cea086f49f27f37e393114860baab130a0642ce629c0aa18.cfe-internal.js';

var useDidUpdateBase = function useDidUpdateBase(useEffectFunction, func, deps) {
  var isFirstRenderRef = useRef(true);
  useEffectFunction(function () {
    if (isFirstRenderRef.current) {
      isFirstRenderRef.current = false;
      return undefined;
    }

    return func();
  }, deps);
};
/**
 * Wrapper around useEffect that runs on dependency updates only, not on initial render.
 * @param func - The effect function to run when dependencies have been updated.
 * @param deps - The list of dependencies to watch for changes.
 */


var useDidUpdate = function useDidUpdate(func, deps) {
  return useDidUpdateBase(useEffect, func, deps);
};
/**
 * Wrapper around useSSRLayoutEffect that runs on dependency updates only, not on initial render.
 * @param func - The effect function to run when dependencies have been updated.
 * @param deps - The list of dependencies to watch for changes.
 */

var useEnhancedDidUpdate = function useEnhancedDidUpdate(func, deps) {
  return useDidUpdateBase(useSSRLayoutEffect, func, deps);
};

export { useDidUpdate, useEnhancedDidUpdate };
